module.exports = __webpack_public_path__ + "img/reference-mediashop.4fba1676.jpg";